<template>
  <v-app class="app-tabela">
    <div class="box" style="margin-top: 0px">
      <v-card class="tabela">
        <v-card-title>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Nome"
            class="input-bottom"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          @pagination="getPagination"
          :page="currentPage"
          :footer-props="{
            itemsPerPageText: '',
            'items-per-page-options': [10],
            'disable-items-per-page': true,
          }"
          :loading="loading"
          loading-text="Carregando, Por favor espere"
          :headers="headers"
          :items="indexedItems"
          :item-class="getRowColor"
          :search="search"
          :single-expand="true"
          :expanded.sync="expanded"
          item-key="id"
          show-expand
          class="elevation-1"
          @item-expanded="onItemExpanded"
        >
          <!-- <template #footer.prepend>
          <v-spacer />
        </template> -->
          <template v-slot:[`footer.page-text`]="items">
            <div class="info-table-item tabela-esus-pec">
              <FonteEsusPecGlobal />
            </div>
            <span class="paginacao"
              >{{ items.pageStart }} - {{ items.pageStop }} de
              {{ items.itemsLength }} famílias</span
            >
          </template>
          <template v-slot:header.micro_area="{ header }">
            {{ header.text }}
            <span
              v-b-tooltip.hover.right
              title="Microárea do ACS"
              class="icon-tooltip"
            >
              <i class="icofont-info-circle"></i>
            </span>
          </template>

          <template v-slot:item.dt_nascimento="{ item }">
            {{ formatDate(item.dt_nascimento) }}
          </template>
          <template v-slot:item.ult_tria="{ item }">
            <div class="date-container">
              <div>{{ formatDate(item.ult_tria) }}</div>
              <div class="months-text">
                ({{ calculateTimeDifference(formatDate(item.ult_tria)) }})
              </div>
            </div>
          </template>

          <template v-slot:expanded-item="{ headers, item }">
            <td colspan="9">
              <table class="table table-interna table-interna-acompanhamento">
                <thead>
                  <tr>
                    <th>CPF</th>
                    <th>CNS</th>
                    <th v-if="exibirCopilot">Suporte</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{ item.nu_cpf }}</td>
                    <td>{{ item.nu_cns }}</td>
                    <td v-if="exibirCopilot">
                      <copilot :item="item" :rules="item.rules"></copilot>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </template>
          <template v-slot:progress>
            <v-progress-linear
              color="blue"
              :height="10"
              indeterminate
            ></v-progress-linear>
          </template>
          <template v-slot:no-data>
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>
          <template v-slot:no-results style="padding: 0px">
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>
        </v-data-table>
      </v-card>
    </div>
  </v-app>
</template>

<script>
import Vue from 'vue'
import * as Functions from './functions'
import utils from '@/mixins/utils.js'
import ShowHideField from '@/components/utils/ShowHideField.vue'
import Copilot from '@/components/Copilot.vue'
import { rulesCopilot } from './copilot.js'

export default {
  name: 'TabelaCadastros',
  components: {
    ShowHideField,
    Copilot,
  },
  props: {
    cadastros: {
      type: Array,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [utils],
  data() {
    return {
      currentPage: 1,
      expanded: [],
      enabled: null,
      search: '',
      headers: [
        {
          text: 'Responsável familiar',
          align: 'start',
          filterable: true,
          value: 'no_cidadao',
        },
        {
          text: 'Nascimento',
          align: 'start',
          filterable: false,
          value: 'dt_nascimento',
        },
        {
          text: 'MA',
          align: 'start',
          filterable: false,
          value: 'micro_area',
        },
        {
          text: 'TRIA',
          align: 'start',
          filterable: false,
          value: 'ult_tria',
        },
        {
          text: 'Avaliados',
          align: 'start',
          filterable: false,
          sortable: true,
          value: 'respostas',
        },
        {
          text: 'Necessidade',
          align: 'start',
          filterable: false,
          value: 'inseguranca_alimentar',
        },
        { text: '', value: 'data-table-expand' },
      ],
    }
  },
  watch: {
    cadastros: {
      handler(newValue, oldValue) {
        this.currentPage = 1
      },
      deep: true,
    },
    search: {
      handler(newValue) {
        if (newValue) {
          this.$emit('filterSearch', { filter: this.filterItems(newValue) })
          return
        }
        this.$emit('filterSearch', { filter: false })
      },
      deep: true,
    },
  },
  computed: {
    formattedDateWithMonthsDifference(data) {
      const monthsDifference = this.calculateMonthsDifference(data)
      return `${data} (${monthsDifference} ${
        monthsDifference === 1 ? 'mês' : 'meses'
      })`
    },
    exibirCopilot() {
      if (this.$store.state.infoMunicipio?.exibe_whatsapp == '1') {
        return true
      }
      return false
    },
    indexedItems() {
      if (this.cadastros !== undefined) {
        return this.cadastros.map((item, index) => {
          return {
            id: index,
            ...item,
          }
        })
      }
    },
  },
  methods: {
    /**
     * Filtra os registros da tabela com base no texto de busca.
     * Considera apenas as colunas marcadas como filtráveis nos headers.
     * @param {String} search Texto digitado para pesquisa
     * @returns {Array} Lista de itens filtrados
     */
    filterItems(search) {
      const searchTerms = search.toLowerCase().trim()
      const filteredItems = this.cadastros.filter((item) => {
        for (const header of this.headers) {
          if (header.filterable && item.hasOwnProperty(header.value)) {
            const itemValue = String(item[header.value]).toLowerCase()
            if (itemValue.includes(searchTerms)) {
              return true
            }
          }
        }
        return false
      })
      return filteredItems
    },

    /**
     * Atualiza a página atual da tabela.
     * @param {Object} options Dados da paginação
     */
    getPagination(options) {
      this.currentPage = options.page
    },

    /**
     * Retorna a classe CSS da linha da tabela.
     *
     * @param {Object} item
     * @returns {String}
     */
    getRowColor(item) {
      return `table-row-color-${Functions.printTableRow(item)}`
    },

    /**
     * Manipula o evento de expansão de um item da tabela.
     * @param {Object} item Contexto do item expandido
     */
    async onItemExpanded(item) {
      try {
        const rules = await rulesCopilot(item.item)
        Vue.set(item.item, 'rules', rules)
      } catch (error) {
        console.error('Erro ao obter as regras:', error)
      }
    },
  },
}
</script>

<style scoped>
.tabela .green-color {
  color: orange !important;
}
.tabela .red-color {
  color: red !important;
}
</style>
<style scoped lang="scss">
.ultimo-acompanhamento {
  display: flex;
  align-items: center;
  // flex-direction: column;
  gap: 10px;
  span {
    background: #c4e8f6;
    color: #00aeef;
    padding: 5px 10px;
    border-radius: 10px;
    font-size: 11px;
  }
}

.icon-copilot {
  img {
    background: #f7f7f7;
    color: #00aeef;
    border-radius: 10px;
    text-align: center;
    width: 40px;
    padding: 10px;
  }
}
</style>
